import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import { formatRollerDisplay } from '../../../../helpers/format-roller-display'
import { onAnyStandardCell, renderCalcPos } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const stampRollerRollerColumn: CalculationColumn = {
    dataIndex: ['stamp', 'roller', 'roller'],
    title: <RotatedTitle>Вал</RotatedTitle>,
    width: 50,
    // editable: true,
    // FormItem: <VirtualStampRoller />,
    render: renderCalcPos(r =>
        formatRollerDisplay(
            r.withoutCutting ? r.virtualStamp?.roller?.roller : r.stamp?.roller?.roller
        )
    ),
    onCell: onAnyStandardCell,
    // onCell: (record: DataSourceItem) => {
    //     if (isCalculation(record)) {
    //         return { colSpan: 0 }
    //     }
    //     return {
    //         colSpan: 1,
    //         dataIndex: record.withoutCutting ? ['virtualStamp', 'roller'] : ['stamp', 'roller'],
    //         relationPath: record.withoutCutting ? ['virtualStamp', 'roller'] : undefined,
    //         editable: record.withoutCutting,
    //     }
    // },
}
